<app-modal title="Select an Employee" [showCancel]="false" okText="Close">
	<sl-filters [searchOnly]="true" [filters]="filters" (filtersUpdated)="applyFilter($event)"></sl-filters>
	<sl-table [data]="data" [config]="config" [filters]="filters"></sl-table>
</app-modal>